import range from './range'

export default [range(0, 23, true, 'h'), range(0, 59, true, 'm'), range(0, 59, true, 's')]
